import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Users,
  Users2,
  MapPin,
  MessageSquare,
  AlertTriangle,
  Megaphone,
  TrendingUp,
  Bug,
  FileText,
  Database,
  Settings,
  Server,
  LogOut,
  Menu,
  X,
  Music,
  BookOpen,
  Navigation,
  Activity,
  Smartphone,
  RadioTower,
  LifeBuoy,
  Phone,
  Clock,
  Route,
  Key,
  MessageCircle,
  Bell,
  History,
  Shield,
  Laptop,
  Sliders,
  Map,
  Cloud,
  ChevronLeft,
  Wifi,
  Crown,
  Car,
  HeartPulse,
  Mail
} from 'lucide-react';
import LifeShareLogo from './LifeShareLogo';
import UserAvatar from './UserAvatar';
import { useAuth } from '../contexts/AuthContext';

const Sidebar: React.FC = () => {
  const { user, logout } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const menuItems = [
    // ── Genel ──
    { path: '/', icon: LayoutDashboard, label: 'Genel Bakış', category: 'Genel', isExact: true },
    { path: '/live-map', icon: Navigation, label: 'Canlı Harita', category: 'Genel' },
    { path: '/analytics', icon: TrendingUp, label: 'Analizler', category: 'Genel' },

    // ── Kullanıcı Yönetimi ──
    { path: '/users', icon: Users, label: 'Kullanıcılar', category: 'Kullanıcı Yönetimi' },
    { path: '/families', icon: Users2, label: 'Çevreler', category: 'Kullanıcı Yönetimi' },
    { path: '/subscriptions', icon: Crown, label: 'Abonelikler', category: 'Kullanıcı Yönetimi' },
    { path: '/user-statuses', icon: HeartPulse, label: 'Kullanıcı Durumları', category: 'Kullanıcı Yönetimi' },
    { path: '/devices', icon: Smartphone, label: 'Cihazlar', category: 'Kullanıcı Yönetimi' },
    { path: '/sessions', icon: Laptop, label: 'Oturumlar', category: 'Kullanıcı Yönetimi' },
    { path: '/password-resets', icon: Key, label: 'Şifre Sıfırlama', category: 'Kullanıcı Yönetimi' },

    // ── Konum & Harita ──
    { path: '/places', icon: MapPin, label: 'Yerler', category: 'Konum & Harita' },
    { path: '/location-push', icon: RadioTower, label: 'Konum Push', category: 'Konum & Harita' },
    { path: '/poi', icon: Map, label: 'Popüler Yerler', category: 'Konum & Harita' },
    { path: '/trips', icon: Car, label: 'Yolculuklar', category: 'Konum & Harita' },
    { path: '/routes', icon: Route, label: 'Rotalar', category: 'Konum & Harita' },
    { path: '/location-requests', icon: Navigation, label: 'Konum İstekleri', category: 'Konum & Harita' },
    { path: '/location-history', icon: History, label: 'Konum Geçmişi', category: 'Konum & Harita' },
    { path: '/parking', icon: Car, label: 'Park Yönetimi', category: 'Konum & Harita' },

    // ── Güvenlik ──
    { path: '/verification', icon: Shield, label: 'Doğrulama', category: 'Güvenlik' },
    { path: '/driving', icon: Car, label: 'Sürüş Güvenliği', category: 'Güvenlik' },
    { path: '/emergencies', icon: AlertTriangle, label: 'Acil Durumlar', category: 'Güvenlik' },
    { path: '/sos-contacts', icon: Phone, label: 'SOS Kişileri', category: 'Güvenlik' },
    { path: '/arrival-checks', icon: Clock, label: 'Varış Kontrol', category: 'Güvenlik' },

    // ── İçerik & İletişim ──
    { path: '/stories', icon: BookOpen, label: 'Hikayeler', category: 'İçerik & İletişim' },
    { path: '/story-replies', icon: MessageCircle, label: 'Hikaye Yanıtları', category: 'İçerik & İletişim' },
    { path: '/music', icon: Music, label: 'Müzik Paylaşım', category: 'İçerik & İletişim' },
    { path: '/cms', icon: FileText, label: 'CMS İçerik', category: 'İçerik & İletişim' },
    { path: '/messages', icon: MessageSquare, label: 'Mesajlar', category: 'İçerik & İletişim' },
    { path: '/notifications', icon: Bell, label: 'Bildirimler', category: 'İçerik & İletişim' },
    { path: '/broadcast', icon: Megaphone, label: 'Toplu Bildirim', category: 'İçerik & İletişim' },
    { path: '/support', icon: LifeBuoy, label: 'Destek', category: 'İçerik & İletişim' },
    { path: '/feedback', icon: MessageSquare, label: 'Geri Bildirimler', category: 'İçerik & İletişim' },

    // ── Email ──
    { path: '/email', icon: Mail, label: 'Email Yönetimi', category: 'Email' },

    // ── Raporlar & Loglar ──
    { path: '/weekly-summaries', icon: TrendingUp, label: 'Haftalık Özetler', category: 'Raporlar & Loglar' },
    { path: '/weather-alerts', icon: Cloud, label: 'Hava Durumu', category: 'Raporlar & Loglar' },
    { path: '/crash-reports', icon: Bug, label: 'Crash Reports', category: 'Raporlar & Loglar' },
    { path: '/activity-logs', icon: FileText, label: 'Activity Logs', category: 'Raporlar & Loglar' },

    // ── Ayarlar ──
    { path: '/notification-preferences', icon: Sliders, label: 'Bildirim Tercihleri', category: 'Ayarlar' },
    { path: '/user-preferences', icon: Map, label: 'Harita Tercihleri', category: 'Ayarlar' },
    { path: '/privacy-settings', icon: Shield, label: 'Gizlilik Ayarları', category: 'Ayarlar' },
    { path: '/settings', icon: Settings, label: 'Genel Ayarlar', category: 'Ayarlar' },

    // ── Sistem ──
    { path: '/api-status', icon: Wifi, label: 'API Status', category: 'Sistem' },
    { path: '/websocket', icon: Wifi, label: 'WebSocket', category: 'Sistem' },
    { path: '/server', icon: Server, label: 'Sunucu Yönetimi', category: 'Sistem' },
    { path: '/backup', icon: Database, label: 'Yedekleme', category: 'Sistem' },
    { path: '/feature-status', icon: HeartPulse, label: 'Özellik Durumu', category: 'Sistem' },
    { path: '/admin-sessions', icon: Shield, label: 'Admin Oturumları', category: 'Sistem' },
  ];

  return (
    <>
      {/* Mobile Menu Button - Only show when sidebar is closed */}
      {!isMobileMenuOpen && (
        <button
          onClick={() => setIsMobileMenuOpen(true)}
          className="lg:hidden fixed top-4 left-4 z-[60] p-2.5 bg-purple-600 text-white rounded-xl shadow-lg"
        >
          <Menu className="w-5 h-5" />
        </button>
      )}

      {/* Mobile Overlay */}
      {isMobileMenuOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black/40 z-[50]"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div className={`
        ${isCollapsed ? 'w-[72px]' : 'w-64'} flex-shrink-0 flex flex-col
        bg-white border-r border-gray-200/80
        lg:relative fixed inset-y-0 left-0 z-[55]
        transform transition-all duration-300 ease-in-out
        ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `}>

        {/* Logo */}
        <div className="p-4 border-b border-gray-100 flex items-center justify-between flex-shrink-0">
          {!isCollapsed ? (
            <LifeShareLogo
              size="medium"
              variant="default"
              showText={true}
              className="text-purple-600"
            />
          ) : (
            <LifeShareLogo
              size="small"
              variant="default"
              showText={false}
              className="text-purple-600 mx-auto"
            />
          )}

          {/* Close button on mobile, Collapse button on desktop */}
          <button
            onClick={() => {
              if (window.innerWidth < 1024) {
                setIsMobileMenuOpen(false);
              } else {
                setIsCollapsed(!isCollapsed);
              }
            }}
            className="p-1.5 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <ChevronLeft className={`w-4 h-4 text-gray-400 transition-transform lg:block hidden ${isCollapsed ? 'rotate-180' : ''}`} />
            <X className="w-4 h-4 text-gray-400 lg:hidden" />
          </button>
        </div>

        {/* Navigation - Scrollable */}
        <nav className="flex-1 px-3 py-3 space-y-0.5 overflow-y-auto scrollbar-thin">
          {menuItems.map((item, index) => {
            const Icon = item.icon;
            const prevCategory = index > 0 ? menuItems[index - 1].category : null;
            const showHeader = item.category !== prevCategory;
            return (
              <React.Fragment key={item.path}>
                {showHeader && !isCollapsed && (
                  <div className={`px-3 pb-1.5 ${index === 0 ? 'pt-1' : 'pt-5'}`}>
                    <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">{item.category}</p>
                  </div>
                )}
                {showHeader && isCollapsed && index > 0 && (
                  <div className="my-2 mx-2 border-t border-gray-100" />
                )}
                <NavLink
                  to={item.path}
                  end={item.path === '/'}
                  onClick={() => setIsMobileMenuOpen(false)}
                  title={isCollapsed ? item.label : undefined}
                  className={({ isActive }) =>
                    `flex items-center ${isCollapsed ? 'justify-center' : ''} gap-3 px-3 py-2 rounded-xl transition-all duration-200 group relative ${isActive
                      ? 'bg-purple-50 text-purple-700'
                      : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                    }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && <div className="absolute left-0 top-1/2 -translate-y-1/2 w-[3px] h-5 bg-purple-600 rounded-r-full" />}
                      <Icon className={`w-[18px] h-[18px] flex-shrink-0 transition-colors ${isActive ? 'text-purple-600' : 'text-gray-400 group-hover:text-gray-600'}`} />
                      {!isCollapsed && <span className="font-medium text-[13px]">{item.label}</span>}
                    </>
                  )}
                </NavLink>
              </React.Fragment>
            );
          })}
        </nav>

        {/* User Profile & Logout */}
        <div className="p-3 border-t border-gray-100 flex-shrink-0">
          {user && (
            <div className={`bg-gray-50 rounded-2xl ${isCollapsed ? 'p-2' : 'p-3'}`}>
              {!isCollapsed ? (
                <>
                  <div className="flex items-center gap-3 mb-3">
                    <div className="relative">
                      {user.avatar_url ? (
                        <img
                          src={`https://api.lifeshare.app${user.avatar_url}`}
                          alt=""
                          className="w-10 h-10 rounded-full object-cover"
                        />
                      ) : (
                        <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center text-white font-semibold text-sm">
                          {user.username?.charAt(0).toUpperCase()}
                        </div>
                      )}
                      <span className="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-green-500 rounded-full border-2 border-gray-50" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-semibold text-gray-900 truncate">
                        {user.full_name || user.username}
                      </p>
                      <p className="text-xs text-gray-500 truncate">
                        {user.admin_role === 'super_admin' ? '👑 Süper Admin' : '🛡️ Admin'}
                      </p>
                    </div>
                  </div>

                  <button
                    onClick={logout}
                    className="w-full flex items-center justify-center gap-2 px-3 py-2 bg-white border border-gray-200 hover:bg-red-50 hover:border-red-200 hover:text-red-600 rounded-xl transition-all duration-200 group"
                  >
                    <LogOut className="w-4 h-4 text-gray-400 group-hover:text-red-500 transition-colors" />
                    <span className="text-sm text-gray-600 group-hover:text-red-600 transition-colors">Çıkış Yap</span>
                  </button>
                </>
              ) : (
                <div className="flex flex-col items-center gap-2">
                  <div className="relative">
                    {user.avatar_url ? (
                      <img
                        src={`https://api.lifeshare.app${user.avatar_url}`}
                        alt=""
                        className="w-9 h-9 rounded-full object-cover"
                      />
                    ) : (
                      <div className="w-9 h-9 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center text-white font-semibold text-xs">
                        {user.username?.charAt(0).toUpperCase()}
                      </div>
                    )}
                    <span className="absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 bg-green-500 rounded-full border-2 border-gray-50" />
                  </div>
                  <button
                    onClick={logout}
                    title="Çıkış Yap"
                    className="w-full flex items-center justify-center p-2 hover:bg-red-50 rounded-xl transition-colors group"
                  >
                    <LogOut className="w-4 h-4 text-gray-400 group-hover:text-red-500 transition-colors" />
                  </button>
                </div>
              )}
            </div>
          )}

          {!isCollapsed && (
            <div className="mt-3 text-center">
              <p className="text-gray-400 text-[10px]">LifeShare Admin v26.29</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Sidebar;
